import { UserManager, UserManagerSettings } from 'oidc-client-ts';

import { AUTHORITY, CLIENT_ID, POST_LOGOUT_REDIRECT_URI, REDIRECT_URI } from '../../enviroments';

const userConfig: UserManagerSettings = {
    authority: AUTHORITY,
    client_id: CLIENT_ID,
    redirect_uri: REDIRECT_URI,
    post_logout_redirect_uri: POST_LOGOUT_REDIRECT_URI,
    monitorSession: true,
};

const userManager = new UserManager(userConfig);

export default userManager;
